import Result from "@/core/common/Result";

export interface IDesativarVoucherUseCase {
  desativarVoucher(id: string): Promise<Result<void>>;
}

export const desativarVoucherUseCaseDI = "desativarVoucherUseCaseDI";
